import React, { useEffect, useState } from 'react';
import { WorkflowInputLayout } from './WorkflowInputLayout';
import EconomicTab from '../../../components/utility_planning/scenarioInputs/EconomicTab';
import { getMdhdWorkflowConfig, updateMdhdWorkflowConfig } from '../../../utils/mdhdWorkflowConfig';

const defaultEconomic = {
  touSource: 'library',
  touDatasetId: null,
  touRates: null,
  touRateMeta: null,
  touRateDetails: null,
  v2gMode: 'unmanaged',
  vehiclePricingDatasetId: null,
};

export default function ManagedChargingInputPage() {
  const [data, setData] = useState(() => ({
    ...defaultEconomic,
    ...getMdhdWorkflowConfig().managedCharging,
  }));
  const updateData = (next) => setData((prev) => ({ ...prev, ...next }));

  useEffect(() => {
    updateMdhdWorkflowConfig('managedCharging', data);
  }, [data]);

  return (
    <WorkflowInputLayout title="Managed charging">
      <div className="bg-white rounded-xl shadow-lg font-ui">
        <EconomicTab data={data} updateData={updateData} section="managed" />
      </div>
    </WorkflowInputLayout>
  );
}
